var duvet;
var pillowcases;
var sheets;
var allData;

let getParams = new Promise(function (resolve, reject) {
    if (allData) {
        resolve("done");
    }

    $.ajax({
        url: '/catalog/constructor/sizes',
        method: 'get',
        dataType: 'json',
        success: function(data){
            allData = data;
            duvet = data.duvet;
            pillowcases = data.pillowcases;
            sheets = data.sheets;

            resolve("done");
        }
    });
})

function SliderDesktop(typeLinen, type, viewSize, minSize, maxSize) {
    const minSizeSlider = minSize;
    const maxSizeSlider = maxSize;

    const changeValue = (type, subtype, dimension, value) => {
        if (document.querySelector(`.range-slider--current-value[data-type=${type}][data-subtype=${subtype}][name=${dimension}]`)) {
            document.querySelectorAll(`.range-slider--current-value[data-type=${type}][data-subtype=${subtype}][name=${dimension}]`).forEach(item => {
                item.value = value;
                item.dispatchEvent(new Event('slide'));
            })
        }
    }

    const changeSlider = (el, min, max, value) => {
        $(el).children('.ui-slider-handle').children('.curValue').text(value);
        $(el).children('.line-before').css({ 'width': '' + ((value - min) / (max - min)) * 100 + '%' });
    }

    $(function () {
        $(`.slider-range-${viewSize}-${typeLinen}-${type}`).each(function () {
            if ($(this).slider('instance')) {
                $(this).slider('destroy');
            }
            $(this).slider({
                step: 1,
                min: minSizeSlider,
                max: maxSizeSlider,
                value: minSizeSlider,
                slide: function (event, ui) {
                    const value = Math.round(ui.value);

                    changeSlider(this, minSizeSlider, maxSizeSlider, value)
                    changeValue(typeLinen, type, viewSize, value);

                    this.querySelector('.line-before').classList.add('sliding')
                },
                stop: function (event, ui) {
                    let value = Math.round(ui.value);
                    $(this).slider('value', value);

                    changeSlider(this, minSizeSlider, maxSizeSlider, value)
                    changeValue(typeLinen, type, viewSize, value);

                    this.querySelector('.line-before').classList.remove('sliding')
                },
                create: function (event, ui) {
                    $(this).children('.ui-slider-handle').append(`<span class="curValue"></span>`);

                    const value = $(this).slider("option", "value");
                    $(this).children('.ui-slider-handle').children('.curValue').text(value);

                    if (this.closest('.range-slider').querySelector('.range-slider-values')) {
                        this.closest('.range-slider')
                            .querySelector('.range-slider-values:first-child')
                            .querySelector('span').innerHTML = minSizeSlider

                        this.closest('.range-slider')
                            .querySelector('.range-slider-values:last-child')
                            .querySelector('span').innerHTML = maxSizeSlider
                    }

                    changeSlider(this, minSizeSlider, maxSizeSlider, value)
                    changeValue(typeLinen, type, viewSize, value);
                }
            });
        });
    });
}

if ("/catalog/constructor" !== document.location.pathname) {
    getParams.then(function () {
            for (let typeLiner in allData) {
                for (let type in allData[typeLiner][1]) {
                    for (let viewSize in allData[typeLiner][1][type]) {
                        SliderDesktop(typeLiner, type, viewSize, allData[typeLiner][1][type][viewSize]['min_size'], allData[typeLiner][1][type][viewSize]['max_size'])
                    }
                }
            }
        }
    );
}

$(function () {

    var sheet = document.createElement('style'),
        $rangeInput = $('.range input'),
        prefs = ['webkit-slider-runnable-track', 'moz-range-track', 'ms-track'];

    document.body.appendChild(sheet);

    var getTrackStyle = function (el) {
        var curVal = el.value,
            val = (curVal - 1) * 16.666666667,
            style = '';

        // Set active label
        $('.range-labels li').removeClass('active selected');

        var curLabel = $('.range-labels').find('li:nth-child(' + curVal + ')');

        curLabel.addClass('active selected');
        //   curLabel.prevAll().addClass('selected');

        for (var i = 0; i < prefs.length; i++) {
            style += '.range {transform: translateX(' + val + '%)}';
        }
        return style;

        // Change background gradient
        //   for (var i = 0; i < prefs.length; i++) {
        //     style += '.range {background: linear-gradient(to right, #37adbf 0%, #37adbf ' + val + '%, #fff ' + val + '%, #fff 100%)}';
        //     style += '.range input::-' + prefs[i] + '{background: linear-gradient(to right, #37adbf 0%, #37adbf ' + val + '%, #b2b2b2 ' + val + '%, #b2b2b2 100%)}';
        //   }

        //   return style;
    }

    $rangeInput.on('input', function () {
        sheet.textContent = getTrackStyle(this);
    });

    // Change input value on label click
    $('.range-labels li').on('click', function () {
        var index = $(this).index();

        $rangeInput.val(index + 1).trigger('input');

    });

    // Клик по кнопке типа
    $('.calc-type-btn').on('click', function () {
        $(this).addClass("active");
        $(this).siblings().removeClass('active');
        i = $(this).attr("data-step");

        const productBody = $('.product__body.calc[data-step="' + i + '"]');
        const colorNavHeader = $('.color-nav-header.color[data-step="' + i + '"]');

        productBody.siblings().removeClass('active');
        productBody.addClass('active');

        $('.color-nav-header.color').removeClass('active');
        colorNavHeader.addClass('active');

        if ($(window).width() < 762) {
            offsetTop = $('.calc-wrapper-item.active').children('.calc-body-wrapper').children('.product__body.active').children('.product__form').children('.product__form-body').children('.product-settings-wrapper').offset();
            blockHeight = $('.calc-video-img').outerHeight();
            $('.calc-video-img').css({ top: '' + offsetTop.top - blockHeight + 'px' });
        }
        window.kitConstructor.setImage(i.slice(0, 1), i.slice(1, 2), window.kitConstructor.isTwoColor());
    });

    // Выбор цвета
    $(document).on('change', '.product__form-radio-inp[name="color"]', function () {
        const label   = $(this).siblings('label.product__form-radio-label');
        const color   = label[0].dataset.color;
        const pattern = label[0].dataset.pattern;
        console.log('change first color');
        console.log(label);
        if (window.kitConstructor.isTwoColor())
            window.kitConstructor.setImageColor(color, pattern, 'calc-fcolor-1');
        else
            window.kitConstructor.setImageColor(color, pattern, 'calc-fcolor');

        window.kitConstructor.updateColorName();
    });

    $(document).on('change', '.product__form-radio-inp[name="second_color"]', function () {
        const label   = $(this).siblings('label.product__form-radio-label');
        const color   = label[0].dataset.color;
        const pattern = label[0].dataset.pattern;

        window.kitConstructor.setImageColor(color, pattern, 'calc-fcolor-2');
        window.kitConstructor.updateColorName();
    });

    $('.calc-steps-item').on('click', function () {
        const step = parseInt($(this).attr("data-step"));
        window.kitConstructor.setStep(step);
    });

    $('.calc-step').on('click', function () {
      const headerHeight = $('header').outerHeight();
      const top = $(".calc-steps-wrapper").offset().top - headerHeight - 30;
      $('body,html').animate({
        scrollTop: top
      }, 1000);
    });

    $('.calc-step.next').on('click', function () {
        window.kitConstructor.setStep(window.kitConstructor.step + 1);
    });

    $('.calc-step.prev').on('click', function () {
        window.kitConstructor.setStep(window.kitConstructor.step - 1);
    });

    $('.end-calc').on('click', function () {
        $('.pp-cart').addClass('show');
    });

    $('input.calc-color-btn').on('change', (e) => {
        const wrapper            = $(e.target).closest('.toggle-two-color-wrapper');
        const currentColorPicker = wrapper.closest('.color-picker-wrapper');
        const firstColorPicker   = currentColorPicker.parent().children('.color-picker-wrapper.first');
        const secondColorPicker  = currentColorPicker.parent().children('.color-picker-wrapper.second');

        const activeImage = $('.calc-img.active');
        const step        = activeImage.data('step');
        const mod         = activeImage.data('mod');
        const colors      = window.kitConstructor.getSelectedColors();

        const twoColor = window.kitConstructor.isTwoColor();

        window.kitConstructor.setImage(step, mod, twoColor);
        if (twoColor) {
            firstColorPicker.find('.product__form-radios span').show()
            secondColorPicker.show();
            window.kitConstructor.setImageColor(colors[0].color, colors[0].pattern, 'calc-fcolor-1');
            window.kitConstructor.setImageColor(colors[1].color, colors[1].pattern, 'calc-fcolor-2');
        } else {
            firstColorPicker.find('.product__form-radios span').hide()
            secondColorPicker.hide();
            window.kitConstructor.setImageColor(colors[0].color, colors[0].pattern, 'calc-fcolor');
        }

        if ($(window).width() < 762) {
            const offsetTop = $('.calc-wrapper-item.active').children('.calc-body-wrapper').children('.product__body.active').children('.product__form').children('.product__form-body').children('.product-settings-wrapper').offset();
            const blockHeight = $('.calc-video-img').outerHeight();
            $('.calc-video-img').css({ top: '' + offsetTop.top - blockHeight + 'px' });
        }

        window.kitConstructor.updateColorName();
    })
});

var i;

document.addEventListener("DOMContentLoaded", async () => {
    document.querySelectorAll('.range-slider--current-value').forEach(item => {
        item.addEventListener('slide', async (event) => {
            let value = parseInt(event.target.value)
            event.target.value = `${value} СМ`;
        })
    })

    document.querySelectorAll('.range-slider--current-value').forEach(item => {
        item.addEventListener('change', async (event) => {
            let value = parseInt(event.target.value) || 0;
            const dimension = event.target.name;
            const type = event.target.dataset.type;
            const subtype = event.target.dataset.subtype;
            const variant = event.target.dataset.variant;

            const size = allData[type][variant][subtype];
            const min = size[dimension].min_size;
            const max = size[dimension].max_size;

            value < min && (value = min);
            value > max && (value = max);

            event.target.value = `${value} СМ`;

            $(`.slider-range-${dimension}-${type}-${subtype}`).each(function () {
                $(this).slider('value', value)

                $(this).children('.ui-slider-handle').children('.curValue').text(value);
                $(this).children('.line-before').css({ 'width': '' + ((value - min) / (max - min)) * 100 + '%' });
            })
        })
    })
})

function Constructor() {
    this.slugs = {
        1: "sheet",
        2: "duvet",
        3: "pillow",
        4: "sheet_elastic",
        5: "sheet_elastic_round",
        6: "sheet_elastic_pocket"
    }

    this.selectedVariant = 1;

    this.data = {
        height: [],
        square: []
    };

    this.colors = [];

    this.step = 0;

    this.init = function() {
        this.getData()
            .then(data => this.data = data)
            .catch(reason => console.log(reason))

        this.getColors()
            .then(({colors}) => {
                this.colors = colors
                document.querySelectorAll('.calc__cloth-variants__item.disabled')
                    .forEach(item => {
                        item.classList.remove('disabled');
                    });
            })
            .catch(reason => console.log(reason));

        return this
    }

    this.getData = async () => {
        const response = await axios.get('/catalog/constructor/prices');
        const { data } = response;

        return data;
    }

    this.getColors = async () => {
        const {data} = await axios.get('/catalog/constructor/colors');

        return data;
    }

    this.getCloths = async () => {
        const { data } = await axios.get('/catalog/constructor/cloths');
        const { cloths } = data;

        return cloths;
    }

    this.renderColors = (variant) => {
        const colors = [...this.colors[variant]];

        document.querySelectorAll('.color-template').forEach(item => {
            const container = item.closest('div');
            const label = $(container).children('label');
            const insertTarget = label.length ? label : $(container).children('template');
            container.querySelectorAll('.product__form-radio').forEach(item => item.remove());

            const type = item.dataset.type;
            const isMulti = !!item.dataset.multi;
            let activeColors = [...colors.filter(color => "inactive" !== color[`status_${type}`])]
            isMulti && (activeColors = [...activeColors.filter(color => "inactive" !== color['status_multi'])]);

            let current = activeColors.find(color => "active" === color[`status_${type}`]);
            isMulti && (current = activeColors.find(color => "active" === color[`status_${type}`] && "active" === color['status_multi']))

            document.querySelectorAll(`h3[data-color-name='${type}']`)
                .forEach(item => item.innerHTML = current.name)

            document.querySelectorAll(`path[data-color='${type}']`)
                .forEach(item => {
                    if (current.image) {
                        item.setAttribute('fill', `url(#img${current.id})`)
                        item.style.fill = `url(#img${current.id})`;
                    } else {
                        item.setAttribute('fill', current.color)
                        item.style.fill = current.color
                    }
                })
            activeColors.forEach((color, i) => {
                const node = item.content.cloneNode(true);
                const status = color[`status_${type}`];
                const multi = color['status_multi'];

                const input = node.querySelector('input');
                const label = node.querySelector('label');

                const {id, color:hex, name, image} = color;

                input.id += id + '-' + container.closest('.product__body.calc').dataset.step;
                input.value = id;

                current === color && (input.checked = true);

                label.setAttribute('for', input.id);
                label.setAttribute('data-color', hex);
                label.setAttribute('data-color-name', name);
                label.setAttribute('style', `--tooltip-color: ${hex}`);

                image || node.querySelector('.color-background').remove();

                if (image) {
                    const imageEl = node.querySelector('.color-background');
                    imageEl.src = `/storage/${image}`;
                    imageEl.setAttribute('alt', `${id}-background`);

                    label.setAttribute('data-pattern', `img${id}`);

                    document.querySelectorAll('.calc-img').forEach(item => {
                        const defs = item.querySelector('defs');

                        if (defs.querySelector(`#img${id}`)) {
                            return;
                        }

                        const pattern = document.createElementNS('http://www.w3.org/2000/svg', 'pattern');
                        pattern.id = `img${id}`;
                        pattern.setAttribute('patternUnits', 'userSpaceOnUse');
                        pattern.setAttribute('width', '40');
                        pattern.setAttribute('height', '40');

                        const img = document.createElementNS('http://www.w3.org/2000/svg','image');
                        img.setAttribute('href', `/storage/${image}`);
                        img.setAttribute('x', '0');
                        img.setAttribute('y', '0');
                        img.setAttribute('width', '40');
                        img.setAttribute('height', '40');

                        pattern.appendChild(img)
                        defs.appendChild(pattern)
                    })
                }

                if (isMulti) {
                    ('not_available' === status || 'not_available' === multi) && node.querySelector('.product__form-radio').classList.add('disable');
                    !('not_available' === status || 'not_available' === multi) && node.querySelector('img').remove();
                } else {
                    'not_available' === status && node.querySelector('.product__form-radio').classList.add('disable');
                    'not_available' !== status && node.querySelector('img').remove();
                }



                $(node).insertBefore(insertTarget);
            });
        })

        $('.product__form-radio').click(function () {
            $(this).addClass('checked');
            $(this).siblings().removeClass('checked');
        });
    }

    this.removeButtons = (variant) => {
        let buttons = document.querySelectorAll(".calc-type-btn");
        let setActive = false;
        let step = 0;

        buttons.forEach(button => {
           if (button.dataset.variant != variant) {
                   button.style.display = 'none';
                   button.classList.remove('active');
           } else {
               button.style.display = 'revert';

               if (button.dataset.step[1] == 1) {
                   button.classList.add("active");
               }
           }
        });
    }

    this.setSelectedVariant = (variant) => {
        this.selectedVariant = variant;
        this.renderColors(variant);
        this.removeButtons(variant);

        document.querySelectorAll('.calc-steps-item.disable').forEach(item => item.classList.remove('disable'));

        getParams.then(function () {
                for (let typeLiner in allData) {
                    for (let type in allData[typeLiner][variant]) {
                        for (let viewSize in allData[typeLiner][variant][type]) {
                            SliderDesktop(typeLiner, type, viewSize, allData[typeLiner][variant][type][viewSize]['min_size'], allData[typeLiner][variant][type][viewSize]['max_size'])
                        }
                    }
                }
            }
        );

        this.processSelectedVariant()
    }

    this.processSelectedVariant = () => {
        try {
            setTimeout(() => {
                if ($(window).width() < 762) {
                    const offsetTop = $('.calc-wrapper-item.active').children('.calc-body-wrapper').children('.product__body.active').children('.product__form').children('.product__form-body').children('.product-settings-wrapper').offset();
                    const blockHeight = $('.calc-video-img').outerHeight();
                    $('.calc-video-img').css({top: '' + offsetTop.top - blockHeight + 'px', opacity: '1',});
                }
            }, 1000);
        } catch (err) {}

        nextStep(1)
    }

    this.calculatePrice = async function(data) {
        if (!this.data.square[this.selectedVariant]) {
            this.data = await this.getData()
        }

        if (this.data.square[this.selectedVariant].length === 0) {
            this.data = await this.getData()
        }

        const {
            'size[height]': height = 0,
            quantity = 1,
            product_type: type,
            type: subtype,
            modify_price,
        } = data

        const heightPrice = this.heightPrice(height);
        const squarePrice = this.squarePrice(data);
        let modify = Number(modify_price) || 0;

        if ((this.selectedVariant === 3 || this.selectedVariant === 2) && parseInt(type) === 2 && parseInt(subtype) === 4) {
            modify += -200;
        }

        if (this.selectedVariant === 1 && parseInt(type) === 2 && parseInt(subtype) === 4) {
            modify += -400;
        }

        // Если наволочка на молнии, то + 100 к цене
        if (parseInt(type) === 3 && parseInt(subtype) === 2) {
            return ((squarePrice + heightPrice + parseInt(this.data.addedValuePillowcases[this.selectedVariant] || '0')) * quantity) + modify
        }

        return (squarePrice + heightPrice) * quantity + modify
    }

    this.squarePrice = function(data) {
        let {
            product_type: type,
            type: subtype,
        } = data

        /* Если выбрана простынь на резинке, для нее отдельные цены */
        if (1 === parseInt(type) && 2 === parseInt(subtype)) {
            type = 4
        }

        /* Если выбрана простынь на резинке круглая, для нее отдельные цены */
        if (1 === parseInt(type) && 3 === parseInt(subtype)) {
            type = 5
        }

        /* Если выбрана простынь на резинке с карманом, для нее отдельные цены */
        if (1 === parseInt(type) && 5 === parseInt(subtype)) {
            type = 6;
        }

        const square = parseInt(this.calculateSquare(data))

        return this.data.square[this.selectedVariant].find(item => {
            return this.slugs[type] === item.type && square <= item.value
        })?.amount || this.data.square[this.selectedVariant][this.data.square[this.selectedVariant].length - 1].amount
    }

    this.heightPrice = function(height = 0) {
        const amount = this.data.height[this.selectedVariant].find(item => {
            return height <= item.value
        })?.amount;

        if (undefined === amount) {
            return this.data.height[this.selectedVariant][this.data.height[this.selectedVariant].length - 1].amount
        }

        return amount;
    }

    this.calculateSquare = function(data) {
        const {
            'size[length]': length = 0,
            'size[width]': width = 0,
            'size[diameter]': diameter = 0,
            'size[height]': height = 0
        } = data

        if (diameter && height) {
            return diameter * diameter
        } else if (diameter) {
            return diameter * diameter
        } else if (height) {
            return length * width
        } else {
            return length * width
        }
    }

    this.getSelectedColors = () => {
        const result = [];
        const activeForm = $('.calc-wrapper-item.active .product__body.calc.active form');
        const selectedFirstColorLabel  = activeForm.find('input[name="color"]:checked ~ label');
        const selectedSecondColorLabel = activeForm.find('input[name="second_color"]:checked ~ label');

        result.push({
            color: selectedFirstColorLabel.data('color'),
            pattern: selectedFirstColorLabel.data('pattern'),
            name: selectedFirstColorLabel.data('color-name'),
        });

        if (activeForm.find('.calc-color-btn[value="1"]:checked').length) {
            result.push({
                color: selectedSecondColorLabel.data('color'),
                pattern: selectedSecondColorLabel.data('pattern'),
                name: selectedSecondColorLabel.data('color-name'),
            });
        }

        return result;
    };

    this.getColorName = () => {
        const colors = this.getSelectedColors();
        const names = colors.map(i => i.name);
        return names.join(" + ");
    };

    this.updateColorName = () => {
        const colorHeader = $('.calc-wrapper-item.active .product__body.calc.active .color-nav-header.color');
        colorHeader.text(this.getColorName())
    };

    this.setImageColor = (color, pattern, pathClass) => {
        const path = $(`.calc-img.active .${pathClass}`);
        if (pattern) {
            path.attr('fill', `${color}`)
            path.css({ "fill": `url(#${pattern})`, "fill-opacity": "0.6" })
        } else {
            path.css({ "fill": `${color}`, "fill-opacity": "0.5" })
        }
    };

    this.setImage = (step, mod, twoColor=false) => {
        let colorClass = 'one-color';
        if (twoColor) {
            colorClass = 'two-color';
        }
        let selector = `.calc-img.${colorClass}[data-step="${step}"]`;
        if (mod !== undefined) {
            selector += `[data-mod="${mod}"]`;
        }

        $('.calc-img').removeClass('active');
        $(selector).addClass('active');
    };

    this.setStep = (step) => {
        if (!(0 <= step && step <= 3)) {
            return;
        }

        const stepItem = $(`.calc-steps-item[data-step="${step}"]`)
        if (0 === step) {
            if (726 < window.screen.width)
                window.kitConstructor.setImage('0');

            $('.calc-step.prev').addClass('disable')
            $('.product__footer.page-calc').hide()
        } else {
            $('.product__footer.page-calc').show()
            $('.calc-step.prev').removeClass('disable')
        }

        stepItem.removeClass('disable');
        $('.calc-steps-item').removeClass('active');
        stepItem.addClass('active');

        if (3 !== step) {
            $('.calc-step.next').removeClass('disable').show();
            $('.calc-step.end-calc').removeClass('active');
        } else {
            $('.calc-step.next').addClass('disable').hide();
            $('.calc-step.end-calc').addClass('active');

            ym(55026505,'reachGoal','choosing-a-pillowcase')
        }

        $('.calc-wrapper-item').removeClass('active');
        $(`.calc-wrapper-item[data-step="${step}"]`).addClass('active');

        $('.calc-wrapper-item.active').find('.calc-type-btn.active').trigger('click');

        if ($(window).width() < 762) {
            const offsetTop = $('.calc-wrapper-item.active').children('.calc-body-wrapper').children('.product__body.active').children('.product__form').children('.product__form-body').children('.product-settings-wrapper').offset();
            const blockHeight = $('.calc-video-img').outerHeight();
            $('.calc-video-img').css({ top: '' + offsetTop.top - blockHeight + 'px' });
        }

        this.step = step;
    };

    this.isTwoColor = () => {
        const activeForm = $('.calc-wrapper-item.active .product__body.calc.active form');
        return activeForm.find('.calc-color-btn[value="1"]:checked').length > 0
    };
}

function AnimatePrice() {
    this.interval = null

    this.init = function() {
        this.interval = null

        return this;
    }

    this.animate = function(el, current, next) {
        clearInterval(this.interval)

        if (1 >= current) {
            el.innerHTML = next
            return;
        }
        if (current === next) {
            return;
        }

        let step = 2;
        const diff = Math.abs(current - next)

        diff > 100 && (step = 16)
        diff >= 500 && (step = 24)
        diff >= 1000 && (step = 32)

        if (current > next) {
            this.interval = setInterval(() => {
                el.innerHTML = (current -= step) < next && (current = next) || current

                if (current <= next) {
                    clearInterval(this.interval)
                }
            }, 2)
        } else {
            this.interval = setInterval(() => {
                el.innerHTML = (current += step) > next && (current = next) || current

                if (current >= next) {
                    clearInterval(this.interval)
                }
            }, 2)
        }
    }
}

window.animatePrice = (new AnimatePrice()).init()
window.kitConstructor = (new Constructor()).init();
